export default {
  "adjustAppConfig.thead.id": "ID",
  "adjustAppConfig.thead.no": "#No",
  "adjustAppConfig.thead.appToken": "AppToken",
  "adjustAppConfig.thead.register": "Register",
  "adjustAppConfig.thead.firstDeposit": "FirstDeposit",
  "adjustAppConfig.thead.deposit": "Deposit",
  "adjustAppConfig.thead.operator": "Operator",
  "adjustAppConfig.thead.action": "action",
  "adjustAppConfig.action.create": "Create",
  "adjustAppConfig.action.edit": "Edit",
  "adjustAppConfig.action.delete": "Delete",
  "adjustAppConfig.copy.success": "Copy Success!!!",
  "freeSpinConfig.confirm.delete.title": "Delete",
  "freeSpinConfig.confirm.delete.content":
    "Are you sure you want to delete this record?",
  "freeSpinConfig.confirm.ok": "Confirm",
  "freeSpinConfig.confirm.cancel": "Cancel",
};
